import { Typography } from '@mui/material/';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';

const DiffPlaceHolderInstructions: FC = () => {
    const { t } = useTranslation('codeArticle');

    return (
        <Typography
            align="center"
            sx={{
                backgroundColor: 'grey.600',
                borderRadius: 1,
                mt: 2,
                px: 3,
                py: 6,
            }}
        >
            {t('diffInstructions')}
        </Typography>
    );
};

export default DiffPlaceHolderInstructions;
